export default (props = {}) => <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<rect width="16" height="16" transform="translate(0 0.5)" fill="white" fill-opacity="0.01"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.18535 12.9937L5.02612 11.8013L8.20922 8.49365L5.02612 5.186L6.18535 3.99365L10.5217 8.49365L6.18535 12.9937Z" fill="#0057B8"/>
</svg>
